import React from 'react';

const NoAction: React.FC = () => (
  <span />
);

export default NoAction;
